import styled from 'styled-components';

export const MetricRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 2px 4px 0;
`;

export const RelatedMetricsTitle = styled.div`
  padding: 0 2px;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: #494949;
`;
